import React from 'react';
import PropTypes from 'prop-types';
import InputField from './InputField';
import InputErrorText from './InputErrorText';
import InputWrapper from './InputWrapper';

const Input = React.forwardRef(
  (
    {
      dataCy,
      placeholder,
      name,
      type,
      margin,
      width,
      maxWidth,
      hasError,
      errorText,
      handleChange,
      autoComplete,
      justifyContent,
      paddingBottom,
    },
    ref,
  ) => (
    <InputWrapper paddingBottom={paddingBottom} margin={margin} justifyContent={justifyContent}>
      <InputField
        data-cy={dataCy}
        onChange={handleChange}
        placeholder={placeholder}
        name={name}
        type={type}
        width={width}
        maxWidth={maxWidth}
        hasError={hasError}
        autoComplete={autoComplete}
        ref={ref}
      />
      {errorText && <InputErrorText data-cy={`${dataCy}-error`}>{errorText}</InputErrorText>}
    </InputWrapper>
  ),
);

Input.propTypes = {
  dataCy: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  margin: PropTypes.string,
  paddingBottom: PropTypes.string,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  hasError: PropTypes.bool,
  errorText: PropTypes.string,
  handleChange: PropTypes.func,
  autoComplete: PropTypes.string,
  justifyContent: PropTypes.string,
  ref: PropTypes.element,
};

export default Input;
